export const driver = {
  deleteTip: "司机{0}将被删除。确定要继续吗？",
  driveDetails: "司机详情",
  editDriver: "编辑司机",
  newDriver: "新建司机",
  useFaceIDPhoto: "使用面部识别照片",
  userSameEmailAddress: "已存在用此电子邮箱注册的用户。",
};
